export class UdeuFile {
    uuid?: string;
    fileId?: string;
    name: string;
    title: string;
    description: string;
    mimetype: string;
    size: number;
    modified: string;

    constructor(uuid: string, fileId: string, name: string, title?: string, description?: string) {
        this.uuid = uuid;
        this.fileId = fileId;
        this.name = name;
        this.title = title;
        this.description = description;
    }
}

export class UdeuCreateFile {
    id: string;
    file: File;
}